import { type KgInsightThemeType } from '@api/api/kg-insights';
import { themeExposureFilterKey } from '@terminal/config/constants';
import { useSearchThemes } from '@terminal/react-query-hooks/themes/useSearchThemes';
import { useFilterOptionSearch } from '@terminal/views/screener/use-filter-option-search/useFilterOptionSearch';
import { useMemo } from 'react';

export const useThemeSearch = (
  useDefaultOptions = true,
  enabled?: boolean,
  types?: KgInsightThemeType[]
) => {
  const isSearchEnabled = enabled ?? true;

  const { handleTextChange, value } = useFilterOptionSearch({
    filter: themeExposureFilterKey,
    defaultOptions: [],
    enabled: false,
  });
  const shouldSearchThemes =
    isSearchEnabled && (useDefaultOptions || !!value.trim());
  const {
    data: searchData,
    isFetching: isFetchingThemes,
    debouncedQuery,
  } = useSearchThemes({
    q: value,
    types,
    enabled: shouldSearchThemes,
  });

  const trimmedQuery = value.trim();
  const isWaitingForDebounce =
    !!trimmedQuery && debouncedQuery !== trimmedQuery;
  const isLoading =
    shouldSearchThemes && (isFetchingThemes || isWaitingForDebounce);

  const themeSearchResults = useMemo(
    () =>
      searchData.map(theme => ({
        ...theme,
        isTheme: true,
      })),
    [searchData]
  );

  return {
    themeSearchResults,
    handleTextChange,
    isLoading,
  };
};
